import { useParams } from 'react-router-dom';
import { DataTableActions } from 'src/components/DataTable';
import { useModal } from 'src/hooks';
import { isModalComplete } from 'src/components/ModalDialog';
import { useStoreUnitActions } from 'src/redux/helpers';
import { useUserRoles } from 'src/auth';
import SolutionAlertRuleEditContainer from './SolutionAlertRuleEditContainer';
import solutionsStore from '../../redux';
import { SolutionAlertRuleItem, SolutionAlertRuleTypeItem } from '../../types';
import SolutionAlertDeleteModal from './SolutionAlertDeleteModal';
import { useSolutionUserRoles } from '../../hooks';

type Props = {
  item?: SolutionAlertRuleItem;
};

function SolutionAlertRulesListAction({ item }: Props) {
  const { solutionId } = useParams();
  const actions = useStoreUnitActions(solutionsStore);
  const { isSolutionEditor } = useSolutionUserRoles(solutionId);
  const onClose = (reason) =>
    isModalComplete(reason) && actions.alertRules(solutionId);
  const updatedItem = {
    ...item,
    subscriptionId:
      item?.subscriptionId !== '00000000-0000-0000-0000-000000000000'
        ? item?.subscriptionId
        : '',
  };
  const [deleteDialog, showDeleteDialog] = useModal(SolutionAlertDeleteModal, {
    item,
    onClose,
  });

  const [editDialog, showEditDialog] = useModal(
    SolutionAlertRuleEditContainer,
    {
      item: updatedItem,
      onClose,
    }
  );

  return (
    <DataTableActions
      canEdit={isSolutionEditor}
      canDelete={
        isSolutionEditor &&
        !(item?.ruleType === SolutionAlertRuleTypeItem.Default)
      }
      onEdit={showEditDialog}
      onDelete={showDeleteDialog}
      showDelete={true}
    >
      {editDialog}
      {deleteDialog}
    </DataTableActions>
  );
}

export default SolutionAlertRulesListAction;
